import storefrontInstance from '@/api/instances/storefront';
import occInstance from './instances/occ';

let cachedWarrantyGeneralIssues = null;

const fetchClaims = (type, params) => {
  const url = `/claims/lines/${type}/`;
  return storefrontInstance.get(url, {params}).then(({data}) => {
    return {
      entries:
        data?.data?.results?.flatMap((claim) =>
          claim.claimLines.map((claimLine) => ({
            ...claim,
            ...claimLine,
          }))
        ) || [],
      pagination: data.data.pagination,
    };
  });
};

const deleteClaims = (claims) => {
  return storefrontInstance.delete(`/claims/delete/${claims}`);
};

const fetchWarrantyIssues = async (serialOrSku) => {
  if (!serialOrSku && cachedWarrantyGeneralIssues) {
    return cachedWarrantyGeneralIssues;
  }
  const params = {
    productCode: serialOrSku,
  };
  const response = await occInstance.get(`warranty/issues`, {params});
  const issues = response?.data?.warrantyIssues || [];
  if (!serialOrSku) {
    cachedWarrantyGeneralIssues = issues;
  }
  return issues;
};

const fetchDataBySerial = async (productSerial) => {
  const response = await occInstance.get(`warranty/serial/${productSerial}`);
  return response.data;
};

const fetchDataBySku = async (productSku) => {
  const response = await occInstance.get(`warranty/sku/${productSku}`);
  return response.data;
};

export {fetchClaims, deleteClaims, fetchWarrantyIssues, fetchDataBySerial, fetchDataBySku};
